import request from '@/utils/request/index'
export default {
  // 初始化QF
  getQFInitDataInOutsideLogic(params) {
    return request.post('/v1/front/lab/gpd/outsideLogic/getQFInitData', params)
  },
  // 获取Outside数据
  getOutsideLogicDataInOutsideLogic(params) {
    return request.post('/v1/front/lab/gpd/outsideLogic/getOutsideLogicData', params)
  }
}